import React from "react";
import { Card, Tab, Tabs, CardContent } from "@material-ui/core";
import TeamMembersTable from "pages/dashboard/settings/property/stages/members";
import InterestListFilters from "./filters";
import InterestListDetails from "./update-container";
import InterestListDisclaimers from "./unit-disclaimers";


interface Props {
  path: string;
  id?: string;
}

enum TabsIndex {
  Details = 0,
  Filters = 1,
  Disclaimers = 2,
  TeamMembers = 3,
}

const UpdateInterestListPage: React.FC<Props> = ({ id: interestListId }) => {
  const [tabIndex, setTabIndex] = React.useState<TabsIndex>(0);
  if (!interestListId) return <div>Invalid URL</div>;
  return (
    <>
      <Tabs value={tabIndex} onChange={(_: any, index: TabsIndex) => setTabIndex(index)}>
        <Tab label="Details" />
        <Tab label="Filters" />
        <Tab label="Unit Disclaimers" />
        <Tab label="Team Members" />
      </Tabs>

      <Card>
        <CardContent>

          {tabIndex === TabsIndex.Details && (
            <InterestListDetails interestListId={interestListId} />)}
          {tabIndex === TabsIndex.Filters && (
            <InterestListFilters interestListId={interestListId} />)}
          {tabIndex === TabsIndex.Disclaimers && (
            <InterestListDisclaimers interestListId={interestListId} />
          )}
          {tabIndex === TabsIndex.TeamMembers && (
            <TeamMembersTable listId={interestListId} isAdmin path="" />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default UpdateInterestListPage;
